import React from "react";
import PropTypes from "prop-types";
import styles from "./MainButton.module.scss";

const MainButton = ({
  children,
  disabled = false,
  size = "default",
  ...props
}) => {
  const buttonClass = `
        ${styles.button} 
        ${styles[size]} 
        ${disabled ? styles.disabled : ""}
    `;

  return (
    <button className={buttonClass} disabled={disabled} {...props}>
      {children}
    </button>
  );
};

MainButton.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(["default", "small", "large"]),
};

export default MainButton;
